import { PRODUCT_NAME } from '../constants';

export const convertProdTypeToProdName = productType => {
  return PRODUCT_NAME[productType];
};
